import { GET_DIGITALMENUS } from "./DigitalMenuAction";

export const DigitalMenuReducer = (state, action) => {
  switch (action.type) {
    case GET_DIGITALMENUS:
      return {
        ...state,
        digitalMenus: action.payload,
      };
    default:
      return state;
  }
};

export default DigitalMenuReducer;
